import { useContext, useEffect, useRef } from 'react';

import styles from './QRCodeComponent.module.css';

import { GlobalContext } from '../../../contexts/globalContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

import LightButtonComponent from '../../commons/LightButtonComponent';
import DarkButtonComponent from '../../commons/DarkButtonComponent';
import ClosePageButtonComponent from '../../commons/ClosePageButtonComponent';

const QRCodeComponent = ({ setSeeQrCode, isShared = false, participant, setQrSharedParticipant }) => {

    const { setOpenEditProfile, socketRef, currentConference, setAlertMessage, currentTopic, openEditProfile } = useContext(GlobalContext)

    const qrImagePathRef = useRef(`/assets/cards/${participant._id}.png`)

    useEffect(() => {
        if ((participant.telephone && participant.organization) || isShared) {
            qrImagePathRef.current = `/assets/cards/${participant._id}.png`
        }
    }, [openEditProfile])

    const shareVCard = () => {
        socketRef.current.emit("CONFERENCE_SCREEN_SHARE_VCARD", currentConference._id, participant._id, (callback) => { 
            if (!callback.error) {
                setAlertMessage({ type: "SUCCESS", message: 'QR code is sent.' })
            } else {
                setAlertMessage({ type: "ERROR", message: callback.message })
            }
        });
    }

    return (
        <div className={styles.component} style={{ height: isShared ? 1023 : "" }}>
            <div className={styles.cardDetails} style={{ height: isShared ? "100%" : "", borderRadius: isShared ? 46 : "" }}>
                <div className={styles.title}>Add Contact to Your Phone</div>

                <div className={styles.instructions}>Scan the QR code to add this contact to your phone.</div>

                <div className={styles.title}>{participant.name}</div>

                <div className={styles.qrCard} onClick={() => {
                    if(!isShared){
                        setOpenEditProfile(true)
                    }
                }}>
                    {!openEditProfile && <img src={process.env.REACT_APP_CMS_URL + qrImagePathRef.current} className={styles.qrData} alt={"qrCode"} />}
                </div>
            </div>
            {!isShared && <div className={styles.buttonsFooter}>
                {(currentConference.moderatedBy === participant._id || currentTopic?.moderator._id === participant._id ) && 
                <LightButtonComponent style={{ width: '215px', height: '60px', font: "normal normal 600 20px/60px Bio Sans", borderRadius: 8 }} onClick={shareVCard}>
                    <FontAwesomeIcon className={styles.iconButton} icon={byPrefixAndName.fas['share']} /> Share VCard
                </LightButtonComponent>}
                <DarkButtonComponent style={{ marginLeft: 0, width: '199px', height: '60px', font: "normal normal 600 20px/60px Bio Sans", borderRadius: 8 }}
                    onClick={() => setOpenEditProfile(true)}>
                    <FontAwesomeIcon className={styles.iconButton} icon={byPrefixAndName.fas['pen']} /> Edit VCard
                </DarkButtonComponent>

            </div>}
            <ClosePageButtonComponent
                setClose={() => {
                    if (isShared) {
                        setQrSharedParticipant()
                    } else {
                        socketRef.current.emit("CONFERENCE_HIDE_VCARD", currentConference._id);
                        setSeeQrCode(false);
                    }
                }}
                style={{ fontSize: 48, top: 28, right: 41, color: "#777777" }}
            />
        </div>
    );
}

export default QRCodeComponent;
